import * as FlatModels from '@medsurf/flat-models';
import * as EntityBaseActions from '../base/entity.base.actions';

// <editor-fold desc="Action Types">

/**
 * Action Types
 */
export enum ActionTypes {
  /**
   * Store
   */
  GetEntitySuccess = '[STORE | ENTITY | IMAGE] Get Entity Success',
  GetEntitiesSuccess = '[STORE | ENTITY | IMAGE] Get Entities Success',
  ModifyEntitySuccess = '[STORE | ENTITY | IMAGE] Modify Entity Success',
  ModifyEntitiesSuccess = '[STORE | ENTITY | IMAGE] Modify Entities Success',
  AddEntity = '[STORE | ENTITY | IMAGE] Add Entity',
  UpdateEntity = '[STORE | ENTITY | IMAGE] Update Entity',
  RemoveEntity = '[STORE | ENTITY | IMAGE] Remove Entity',
  UndoSnapshot = '[STORE | ENTITY | IMAGE] Undo Snapshot',
  RedoSnapshot = '[STORE | ENTITY | IMAGE] Redo Snapshot',
  CleanUpSnapshots = '[STORE | ENTITY | IMAGE] Clean Up Snapshots',
  SetImageIndex = '[STORE | ENTITY | IMAGE] Set Image Index',
  RearrangeImages = '[STORE | ENTITY | IMAGE] Rearrange Images',
  /**
   * Request
   */
}

// </editor-fold>

// <editor-fold desc="Models">

// </editor-fold>

// <editor-fold desc="Store">

/**
 * Get Entity Success
 */
export class GetEntitySuccess extends EntityBaseActions.GetEntitySuccess {
  public static readonly type = ActionTypes.GetEntitySuccess;
}

/**
 * Get Entities Success
 */
export class GetEntitiesSuccess extends EntityBaseActions.GetEntitiesSuccess {
  public static readonly type = ActionTypes.GetEntitiesSuccess;
}

/**
 * Modify Entity Success
 */
export class ModifyEntitySuccess extends EntityBaseActions.ModifyEntitySuccess {
  public static readonly type = ActionTypes.ModifyEntitySuccess;
}

/**
 * Modify Entities Success
 */
export class ModifyEntitiesSuccess extends EntityBaseActions.ModifyEntitiesSuccess {
  public static readonly type = ActionTypes.ModifyEntitiesSuccess;
}

/**
 * Add Entity
 */
export class AddEntity extends EntityBaseActions.AddEntity<FlatModels.ImageEntityModels.Image> {
  public static readonly type = ActionTypes.AddEntity;
}

/**
 * Update Entity
 */
export class UpdateEntity extends EntityBaseActions.UpdateEntity<FlatModels.ImageEntityModels.Image> {
  public static readonly type = ActionTypes.UpdateEntity;
}

/**
 * Remove Entity
 */
export class RemoveEntity extends EntityBaseActions.RemoveEntity<FlatModels.ImageEntityModels.Image> {
  public static readonly type = ActionTypes.RemoveEntity;
}

/**
 * Undo Snapshot
 */
export class UndoSnapshot extends EntityBaseActions.UndoSnapshot {
  public static readonly type = ActionTypes.UndoSnapshot;
}

/**
 * Redo Snapshot
 */
export class RedoSnapshot extends EntityBaseActions.RedoSnapshot {
  public static readonly type = ActionTypes.RedoSnapshot;
}

/**
 * Clean Up Snapshots
 */
export class CleanUpSnapshots extends EntityBaseActions.CleanUpSnapshots {
  public static readonly type = ActionTypes.CleanUpSnapshots;
}

/**
 * Set Image Index
 */
export class SetImageIndex {
  public static readonly type = ActionTypes.SetImageIndex;

  public constructor(public imageIndex: number) {
  }
}

/**
 * Rearrange Images
 */
export class RearrangeImages {
  public static readonly type = ActionTypes.RearrangeImages;

  public constructor(public images: FlatModels.ImageEntityModels.Image[] | string[]) {
  }
}

// </editor-fold>

// <editor-fold desc="Request">

// </editor-fold>